import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import Main from '../views/MainView.vue';
import store from '../store/index';
const routes = [
  {
    path: '/',
    name: 'home',
    component: Main,
    meta: { requiresAuth: false },
  },
  {
    path: '/tangtangball',
    name: 'tangtangball',
    component: Home,
    meta: { requiresAuth: false },
  },
  {
    path: '/lotto',
    name: 'lotto',
    component: () => import('../views/Lotto/LottoDrawView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/fortune-cookie',
    name: 'fortuneCookie',
    component: () => import('../views/FortuneCookie/FortuneCookieView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/fortune-cookie/result/:id',
    name: 'fortuneCookieResult',
    component: () => import('../views/FortuneCookie/FortuneCookieResultView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/fortune-cookie/history',
    name: 'fortuneCookieHistory',
    component: () => import('../views/FortuneCookie/FortuneCookieHistoryView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/saju',
    name: 'saju',
    component: () => import('../views/ComingSoonView.vue'),
    props: { title: '사주 보기', description: '사주 보기 메뉴는 준비 중입니다.' },
    meta: { requiresAuth: false },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/password-reset',
    name: 'passwordReset',
    component: () => import('../views/PasswordResetView.vue'),
  },
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/JoinView.vue'),
  },
  {
    path: '/board',
    name: 'boardList',
    component: () => import('../views/Board/MiniBoardView.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: '/points/recharge',
    name: 'pointRecharge',
    component: () => import('../views/Points/PointRechargeView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chat-rooms',
    name: 'chatRooms',
    component: () => import('../views/Chat/ChatRoomListView.vue'),
    meta: { requiresAuth: true, hideHeader: true },
  },
  {
    path: '/chat-rooms/create',
    name: 'chatRoomCreate',
    component: () => import('../views/Chat/ChatRoomCreateView.vue'),
    meta: { requiresAuth: true, hideHeader: true },
  },
  {
    path: '/chat-rooms/:id',
    name: 'chatRoomDetail',
    component: () => import('../views/Chat/ChatRoomDetailView.vue'),
    meta: { requiresAuth: true, hideHeader: true },
  },
  {
    path: '/board/:id',
    name: 'board',
    component: () => import('../views/Board/BoardView.vue'),
    meta: { requiresAuth: true, hidden: true },
  },
  {
    path: '/boardDetail/:id',
    name: 'boardDetail',
    component: () => import('../views/Board/BoardDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/boardDetail',
    name: 'boardCreated',
    component: () => import('../views/Board/BoardDetailView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile/ProfileView.vue'),
    meta: { requiresAuth: true, hideHeader: true },
  },
  {
    path: '/mypage',
    name: 'mypage',
    component: () => import('../views/MyPage/MyPageView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mypage/lotto-numbers',
    name: 'myLottoNumbers',
    component: () => import('../views/MyPage/MyLottoNumbersView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/mypage/predictions',
    name: 'myPredictionHistory',
    component: () => import('../views/MyPage/MyPredictionHistoryView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/messages',
    name: 'messages',
    component: () => import('../views/Messages/MessageListView.vue'),
    meta: { requiresAuth: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 };
  },
});

import axios from 'axios';
const checkAuthentication = async () => {
  const apiBase = process.env.VUE_APP_API_URL || 'http://localhost:3000';
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const response = await axios.post(
      `${apiBase}/auth/users`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      },
    );
    store.commit('setUsers', response.data.user);
    return true;
  } catch (error) {
    // 401 등은 토큰 만료/무효로 간주하고 정중히 false 처리
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
    }
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 사용자가 로그인되어 있는지 확인하는 로직을 추가
    const isAuthenticated = await checkAuthentication(); // 사용자 인증 여부 확인
    if (!isAuthenticated) {
      next({ name: 'login' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
